function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';

var TimePickerDropdown = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(TimePickerDropdown, _React$PureComponent);

  function TimePickerDropdown() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = TimePickerDropdown.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return (
      /*#__PURE__*/

      /* eslint-disable */
      // Disabled due to onClick on div - needed to not close DropDown Prematurely
      React.createElement("div", {
        className: 'md-timepicker__dropdown-container',
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: 'md-timepicker__dropdown'
      }, /*#__PURE__*/React.createElement("div", {
        className: "inline-flex"
      }, children)))
      /* eslint-enable */

    );
  };

  return TimePickerDropdown;
}(React.PureComponent);

TimePickerDropdown.propTypes = {
  /** Children node to render within TimePickerDropdown | null */
  children: PropTypes.node
};
TimePickerDropdown.defaultProps = {
  children: null
};
TimePickerDropdown.displayName = 'TimePickerDropdown';
export default TimePickerDropdown;